export const formatNumberToPriceNumber = (numberToFormat = 0) => {

    let numberPriceReformat = Number(numberToFormat.toString());

    const soldeIsNotInteger = numberPriceReformat.toString().indexOf(".") !== -1;

    if (soldeIsNotInteger) {
        numberPriceReformat = numberPriceReformat.toFixed(2)
    }

    return numberPriceReformat;
}


export const formatNumberToEuroString = (numberToFormat = 0) => {

    let numberEuroString = new Intl.NumberFormat("fr-FR").format(
        formatNumberToPriceNumber(numberToFormat)
    );

    return numberEuroString;
}
